<template>
  <div class="manage-voucher">
    <div
      v-if="!voucherPurchase"
      class="manage-voucher-login__loading"
    >
      <LoadingSpinner />
    </div>

    <div
      v-else
      class="manage-voucher__wrapper"
    >
      <div class="manage-voucher__log-off-btn">
        <SplButton
          variant="link"
          class="manage-voucher__log-off-link"
          @click="logOff"
        >
          <SmallArrowIcon
            :size="10"
            direction="left"
          />

          <DynLang
            by-key="go-back"
            capitalize-first
          />
        </SplButton>
      </div>

      <!-- Modals -->
      <div>
        <Modal
          v-model="isConditionsModalOpened"
          content-full-height
        >
          <template #header>
            <DynLang
              by-key="service-terms-and-conditions"
              capitalize-first
            />
          </template>

          <div class="manage-voucher__spa-terms-conditions">
            <div v-if="serviceTermsAndConditions">
              <div v-html="serviceTermsAndConditions" />
            </div>

            <div v-if="spaConditons">
              <h4>
                {{ spaName }} <DynLang by-key="terms-and-conditions" />:
              </h4>
              <div v-html="spaConditons" />
            </div>

            <div v-if="spalopiaConditons">
              <h4>
                Spalopia.com <DynLang by-key="terms-and-conditions" />:
              </h4>
              <div v-html="spalopiaConditons" />
            </div>
          </div>
        </Modal>

        <Modal v-model="isRedeemModalOpened">
          <template #header>
            <p v-if="!isVoucherExpired">
              <DynLang
                by-key="manage-voucher-form-actions-redeem-modal-title"
                capitalize-first
              />
            </p>
            <p v-else>
              <DynLang
                by-key="manage-voucher-form-is-expired"
                capitalize-first
              />
            </p>
          </template>

          <div class="manage-voucher__modal__contact-spa">
            <div
              v-if="isVoucherExpired"
              class="manage-voucher__modal__contact-spa__expired-notice"
            >
              <div><DynLang by-key="manage-voucher-form-actions-redeem-expired-modal-body-0" /></div>
              <div><DynLang by-key="manage-voucher-form-actions-extend-modal-body-3" /></div>
              <div><DynLang by-key="manage-voucher-form-actions-extend-modal-body-4" /></div>
              <div class="manage-voucher__modal__paragraph">
                <DynLang by-key="manage-voucher-form-actions-redeem-expired-modal-body-3" />
              </div>

              <div class="manage-voucher__modal__email">
                <a href="mailto:ayuda@spalopia.com">ayuda@spalopia.com</a>
              </div>
            </div>

            <p>
              <DynLang by-key="manage-voucher-form-actions-redeem-modal-body-spa-name-a" />
              <strong class="mx-text">{{ spaName }}</strong>
              <DynLang by-key="manage-voucher-form-actions-redeem-modal-body-spa-name-b" />
            </p>

            <div class="manage-voucher__modal__contact-spa__data">
              <p>
                <DynLang by-key="manage-voucher-form-actions-how-to-contact" />
              </p>
              <ul class="manage-voucher__modal__contact-spa__data__list">
                <li v-if="spaContact.email">
                  <DynLang by-key="manage-voucher-form-actions-how-to-contact-email" />
                  <strong class="ml-text">{{ spaContact.email }}</strong>
                </li>
                <li v-if="spaContact.phone">
                  <DynLang by-key="manage-voucher-form-actions-how-to-contact-phone" />
                  <strong class="ml-text">{{ spaContact.phone }}</strong>
                </li>
                <li v-if="spaContact.web">
                  <DynLang by-key="manage-voucher-form-actions-how-to-contact-web" />
                  <strong class="ml-text">{{ spaContact.web }}</strong>
                </li>
              </ul>
            </div>
          </div>
        </Modal>

        <Modal
          v-model="isEditModalOpened"
          @closed="closeEditModal"
        >
          <template #header>
            <DynLang
              v-if="!editModalSuccess"
              by-key="manage-voucher-form-actions-edit"
              capitalize-first
            />
            <Lang
              v-if="editModalSuccess"
              by-key="manage-voucher-info-edit-success-0"
              capitalize-first
            />
          </template>

          <div class="manage-voucher__modal__edit">
            <div
              v-if="!editModalSuccess"
              class="manage-voucher__modal__edit__input"
            >
              <SplInputBox
                v-model="beneficiaryName"
                label-translation-key="manage-voucher-form-beneficiary"
                placeholder-translation-key="input-name-and-surname"
                @blur="onEditInputBlur"
                @focus="onEditInputFocus"
              />
            </div>

            <div
              v-if="editModalSuccess"
              class="manage-voucher__modal__edit__success-top"
            >
              <div class="manage-voucher__modal__edit__success-top__label">
                <Lang by-key="manage-voucher-form-beneficiary" />
              </div>
              <div class="manage-voucher__modal__edit__success-top__beneficiary">
                {{ beneficiaryName }}
              </div>
            </div>

            <div
              v-if="editModalHasErrors"
              class="manage-voucher__modal__edit__error"
            >
              <span>
                *<DynLang
                  by-key="buyer-form-name-and-surname-error"
                  capitalize-first
                />
              </span>
            </div>

            <div
              v-if="editModalSuccess"
              class="manage-voucher__modal__edit__success-bottom"
            >
              <div class="manage-voucher__modal__edit__success-bottom__subhead">
                <Lang by-key="manage-voucher-info-edit-success-1" />
              </div>

              <div class="manage-voucher__modal__edit__success-bottom__btn">
                <SplButton
                  variant="link"
                  @click="downloadVoucher"
                >
                  <span class="manage-voucher__form__service__conditions__download">
                    <DownloadIcon variant="dark" />
                    <DynLang by-key="voucher-file-btn-short" />
                  </span>
                </SplButton>
              </div>
            </div>
          </div>

          <template #bottom>
            <div
              v-if="!editModalSuccess"
              class="manage-voucher__modal__edit__btns"
            >
              <SplButton
                variant="primary"
                size="desk-small-mobile-full"
                @click="saveBeneficiaryEditWrapper"
              >
                <Lang
                  by-key="save"
                  capitalize-first
                />
              </SplButton>

              <SplButton
                variant="white"
                size="desk-small-mobile-full"
                @click="closeEditModal"
              >
                <Lang
                  by-key="discard"
                  capitalize-first
                />
              </SplButton>
            </div>
          </template>
        </Modal>

        <Modal
          v-model="isCancelModalOpened"
          content-full-height
        >
          <template #header>
            <p v-if="!cancelModalSuccess">
              <DynLang
                by-key="manage-voucher-form-actions-cancel-modal-title"
                capitalize-first
              />
            </p>
            <p v-else>
              <DynLang
                by-key="manage-voucher-form-actions-cancel-modal-confim-title"
                capitalize-first
              />
            </p>
          </template>

          <div
            v-if="!cancelModalSuccess"
            class="manage-voucher__modal__cancel"
          >
            <div class="manage-voucher__modal__cancel__text">
              <p>
                <DynLang
                  by-key="manage-voucher-form-actions-cancel-modal-body-00"
                  capitalize-first
                />
              </p>

              <p>
                <DynLang
                  by-key="manage-voucher-form-actions-cancel-modal-body-01"
                  capitalize-first
                />
              </p>
            </div>

            <div class="manage-voucher__modal__cancel__head">
              <DynLang
                by-key="manage-voucher-form-actions-cancel-modal-body-10"
                capitalize-first
              />
            </div>

            <div class="manage-voucher__modal__cancel__text">
              <p>
                <DynLang
                  by-key="manage-voucher-form-actions-cancel-modal-body-11"
                  capitalize-first
                />
              </p>
              <p>
                <DynLang
                  by-key="manage-voucher-form-actions-cancel-modal-body-12"
                  capitalize-first
                />
              </p>
            </div>

            <div class="manage-voucher__modal__cancel__head">
              <DynLang
                by-key="manage-voucher-form-actions-cancel-modal-body-20"
                capitalize-first
              />
            </div>

            <div class="manage-voucher__modal__cancel__text">
              <p>
                <DynLang
                  by-key="manage-voucher-form-actions-cancel-modal-body-21"
                  capitalize-first
                />
              </p>
              <p>
                <DynLang
                  by-key="manage-voucher-form-actions-cancel-modal-body-22"
                  capitalize-first
                />
              </p>
            </div>

            <div class="manage-voucher__modal__cancel__text">
              <p>
                <DynLang
                  by-key="manage-voucher-form-actions-cancel-modal-body-23"
                  capitalize-first
                />
              </p>

              <ul class="manage-voucher__modal__cancel__list">
                <li>
                  <DynLang
                    by-key="manage-voucher-form-actions-cancel-modal-body-24"
                    capitalize-first
                  />
                </li>
                <li>
                  <DynLang
                    by-key="manage-voucher-form-actions-cancel-modal-body-25"
                    capitalize-first
                  />
                </li>
              </ul>
            </div>

            <div class="manage-voucher__modal__cancel__selector">
              <p class="manage-voucher__modal__cancel__selector__header">
                <DynLang
                  by-key="manage-voucher-form-actions-cancel-modal-body-26"
                  capitalize-first
                />
              </p>

              <div>
                <div
                  v-if="needsCancellationReasonError"
                  class="manage-voucher__modal__cancel__selector__error"
                >
                  * <DynLang
                    by-key="manage-voucher-form-actions-cancel-needs-reason-error"
                    capitalize-first
                  />
                </div>

                <div class="manage-voucher__modal__cancel__selector__select-box">
                  <SelectBox
                    id="cancellation-reason"
                    item-label-as-slot
                    variant="border"
                    display-prop="label"
                    :data="cancelReasonList"
                    @input="onCancellationReasonSelected"
                  >
                    <template #label>
                      <DynLang
                        :by-key="currentCancellationReasonLabel"
                        capitalize-first
                      />
                    </template>
                    <template #item="{ element }">
                      <DynLang
                        :by-key="element.label"
                        capitalize-first
                      />
                    </template>
                  </SelectBox>
                </div>

                <div
                  v-if="currentCancellationReason"
                  class="manage-voucher__modal__cancel__selector__extra"
                >
                  <div v-if="currentCancellationReason.needsExtra">
                    <p class="manage-voucher__modal__cancel__selector__extra__header">
                      <DynLang
                        :by-key="currentCancellationReason.extraLabel"
                        capitalize-first
                      />
                    </p>

                    <div class="manage-voucher__modal__cancel__selector__extra__input">
                      <SplInputBox
                        id="cancellation-user-extra"
                        v-model="cancellationReasonUserExtra"
                        :max-length="80"
                        :label-translation-key="currentCancellationReason.extraInputLabel"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            v-else
            class="manage-voucher__modal__cancel"
          >
            <div class="manage-voucher__modal__cancel__text">
              <p>
                <DynLang by-key="manage-voucher-form-actions-cancel-modal-confim-01" />
              </p>
            </div>
            <div class="manage-voucher__modal__cancel__text">
              <p>
                <DynLang by-key="manage-voucher-form-actions-cancel-modal-confim-02" />
              </p>
            </div>
            <div class="manage-voucher__modal__cancel__text">
              <p>
                <DynLang by-key="manage-voucher-form-actions-cancel-modal-confim-03" />
              </p>
            </div>
            <div class="manage-voucher__modal__cancel__thanks">
              <p>
                <DynLang by-key="manage-voucher-form-actions-cancel-modal-confim-04" />
              </p>
            </div>
            <div class="manage-voucher__modal__cancel__center-text">
              <p>
                <DynLang by-key="manage-voucher-form-actions-cancel-modal-confim-05" />
              </p>
            </div>
          </div>

          <template #bottom>
            <div
              v-if="!cancelModalSuccess"
              class="manage-voucher__modal__cancel__btns"
            >
              <SplButton
                variant="primary"
                @click="fromCancelToServiceChange"
              >
                <Lang
                  by-key="manage-voucher-form-actions-cancel-modal-btns-0"
                  capitalize-first
                />
              </SplButton>

              <SplButton
                variant="white"
                @click="cancelVoucherWrapper"
              >
                <Lang
                  by-key="manage-voucher-form-actions-cancel-modal-btns-1"
                  capitalize-first
                />
              </SplButton>
            </div>
          </template>
        </Modal>

        <Modal
          v-model="isServiceChangeModalOpened"
          content-full-height
        >
          <template #header>
            <p>
              <DynLang
                by-key="manage-voucher-form-actions-service-change-modal-title"
                capitalize-first
              />
            </p>
          </template>

          <div>
            <HBSPTVoucherServiceChange
              v-if="isServiceChangeModalOpened"
              :buyer-email="voucherBuyerEmail"
              :voucher-code="voucherCode"
            />
          </div>
        </Modal>

        <Modal
          v-model="isExtendModalOpened"
        >
          <template #header>
            <p>
              <DynLang
                by-key="manage-voucher-form-is-expired"
                capitalize-first
              />
            </p>
          </template>

          <div class="manage-voucher__modal__extend">
            <div class="manage-voucher__modal__highlight">
              <DynLang by-key="manage-voucher-form-actions-extend-modal-body-0" />
            </div>
            <div class="manage-voucher__modal__paragraph">
              <DynLang by-key="manage-voucher-form-actions-extend-modal-body-1" />
            </div>
            <div><DynLang by-key="manage-voucher-form-actions-extend-modal-body-2" /></div>
            <div><DynLang by-key="manage-voucher-form-actions-extend-modal-body-3" /></div>

            <div><DynLang by-key="manage-voucher-form-actions-extend-modal-body-4" /></div>
            <div class="manage-voucher__modal__paragraph">
              <DynLang by-key="manage-voucher-form-actions-extend-modal-body-5" />
            </div>
          </div>

          <div class="manage-voucher__modal__email">
            <a href="mailto:ayuda@spalopia.com">ayuda@spalopia.com</a>
          </div>
        </Modal>
      </div>

      <!-- Contenido principal -->
      <div
        v-if="isVoucherExpired"
        class="manage-voucher__header"
      >
        <p class="manage-voucher__header__title">
          <DynLang
            by-key="manage-voucher-form-is-expired"
            capitalize-first
          />
        </p>
      </div>

      <div
        v-else-if="isVoucherExchanged"
        class="manage-voucher__header"
      >
        <p class="manage-voucher__header__title">
          <DynLang
            by-key="manage-voucher-form-is-exchanged"
            capitalize-first
          />
        </p>

        <p class="manage-voucher__header__subtitle">
          <DynLang
            by-key="manage-voucher-form-is-exchanged-notice"
            capitalize-first
          />
        </p>

        <div class="manage-voucher__modal__email">
          <a href="mailto:ayuda@spalopia.com">ayuda@spalopia.com</a>
        </div>
      </div>

      <div
        v-else-if="isVoucherCancelled"
        class="manage-voucher__header"
      >
        <p class="manage-voucher__header__title">
          <DynLang
            by-key="manage-voucher-form-is-cancelled"
            capitalize-first
          />
        </p>

        <p class="manage-voucher__header__subtitle">
          <DynLang
            by-key="manage-voucher-form-is-cancelled-notice"
            capitalize-first
          />
        </p>

        <div class="manage-voucher__modal__email">
          <a href="mailto:ayuda@spalopia.com">ayuda@spalopia.com</a>
        </div>
      </div>

      <div
        v-else
        class="manage-voucher__header"
      >
        <h2 class="manage-voucher__header__title">
          <DynLang
            by-key="manage-voucher-form-header-title"
            capitalize-first
          />
        </h2>

        <p class="manage-voucher__header__subtitle">
          <DynLang
            by-key="manage-voucher-form-header-subtitle"
            capitalize-first
          />
        </p>

        <p class="manage-voucher__header__info">
          <DynLang
            by-key="manage-voucher-form-header-info"
            capitalize-first
          />
        </p>
      </div>

      <div class="manage-voucher__form">
        <div class="manage-voucher__form__service">
          <div
            v-for="voucher in voucherPurchase.vouchers"
            :key="voucher.uuid"
          >
            <VoucherListItem
              :voucher="voucher"
              :purchase-pricing="voucherPurchaseFinalPrice"
              :spa-name="voucherPurchaseSpaName"
            />
          </div>

          <div class="manage-voucher__form__service__conditions">
            <SplButton
              variant="link"
              @click="openConditionsModalOpened"
            >
              <DynLang
                class="only-desktop-block"
                by-key="service-terms-and-conditions"
                capitalize-first
              />
              <DynLang
                class="only-mobile"
                by-key="terms-and-conditions"
                capitalize-first
              />
            </SplButton>

            <SplButton
              variant="link"
              @click="downloadVoucher"
            >
              <span class="manage-voucher__form__service__conditions__download">
                <DownloadIcon variant="dark" />
                <DynLang by-key="voucher-file-btn-short" />
              </span>
            </SplButton>
          </div>
        </div>

        <div class="manage-voucher__form__purchase">
          <div class="manage-voucher__form__purchase__info">
            <div class="manage-voucher__form__purchase__info__header">
              <DynLang by-key="manage-voucher-form-beneficiary" />
            </div>

            <div class="manage-voucher__form__purchase__info__body">
              <div class="label">
                <DynLang by-key="manage-voucher-form-beneficiary-name" />
              </div>
              <div>
                {{ giftNameSurname }}
              </div>
            </div>

            <div class="manage-voucher__form__purchase__info__header">
              <DynLang by-key="manage-voucher-form-purchase-info" />
            </div>

            <div class="manage-voucher__form__purchase__info__body">
              <div class="label">
                <DynLang by-key="manage-voucher-form-buyer-name" />
              </div>
              <div>
                {{ voucherBuyerName }}
              </div>
            </div>

            <div class="manage-voucher__form__purchase__info__body">
              <div class="label">
                <DynLang by-key="manage-voucher-form-buyer-email" />
              </div>
              <div>
                {{ voucherBuyerEmail }}
              </div>
            </div>

            <div
              v-if="voucherPurchaseConfirmedPaymentType"
              class="manage-voucher__form__purchase__info__body"
            >
              <div class="label">
                <DynLang by-key="manage-voucher-form-buyer-payment-method" />
              </div>
              <div>
                {{ voucherPurchaseConfirmedPaymentType }}
              </div>
            </div>
          </div>

          <!-- Voucher Cambio de nombre -->
          <div
            v-if="!isVoucherExpired && !isVoucherCancelled && !isVoucherExchanged"
            class="manage-voucher__form__purchase__edit"
          >
            <SplButton
              variant="link"
              @click="openEditModal"
            >
              <DynLang by-key="manage-voucher-form-actions-edit" />
            </SplButton>
          </div>

          <!-- Canjear, cambiar servicio, cancelar -->
          <div
            v-if="!isVoucherCancelled && !isVoucherExchanged"
            class="manage-voucher__form__purchase__actions"
          >
            <SplButton
              variant="primary"
              @click="openRedeemModalOpened"
            >
              <DynLang by-key="manage-voucher-form-actions-redeem" />
            </SplButton>

            <template v-if="!isVoucherExpired">
              <SplButton
                v-if="isAfterMorethan14Days"
                variant="white"
                @click="openServiceChangeModalOpened"
              >
                <DynLang by-key="manage-voucher-form-actions-change" />
              </SplButton>

              <SplButton
                v-else
                variant="white"
                @click="openCancelModalOpened"
              >
                <DynLang by-key="manage-voucher-form-actions-cancel" />
              </SplButton>
            </template>

            <template v-else>
              <SplButton
                variant="white"
                @click="openExtendModalOpened"
              >
                <DynLang by-key="manage-voucher-form-actions-extend" />
              </SplButton>
            </template>
          </div>
        </div>
      </div>

      <Separator hide />

      <div class="manage-voucher__faq">
        <div class="manage-voucher__faq__header">
          <DynLang
            by-key="manage-voucher-faq-header"
            capitalize-first
          />
        </div>

        <FAQList :items="faqItems" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import LoadingSpinner from '@/core/components/shared/LoadingSpinner.vue'
import Card from '~/core/components/shared/Card.vue'
import SplInputBox from '~/core/components/shared/form/SplInputBox.vue'
import SplEmailInput from '~/core/components/shared/form/SplEmailInput.vue'
import SplButton from '~/core/components/shared/form/SplButton.vue'
import SelectBox from '~/core/components/shared/form/SelectBox.vue'
import Separator from '~/core/components/shared/Separator.vue'
import Modal from '~/core/components/shared/form/Modal.vue'
import FAQList from '~/core/components/shared/faq/FAQList.vue'
import DownloadIcon from '~/core/components/shared/icons/Download.icon.vue'
import SmallArrowIcon from '~/core/components/shared/icons/SmallArrow.icon.vue'

import VoucherListItem from '~/core/components/manage-voucher/VoucherListItem.vue'
import VoucherPurchaseConditions from '~/core/components/voucher-purchase/VoucherPurchaseConditions.vue'
import HBSPTVoucherServiceChange from '~/core/components/manage-voucher/legacy/HBSPTVoucherServiceChange.vue'

import { useVoucherManagementForm } from '~/core/composable/voucher-purchase/useVoucherManagementForm'
import { useVoucherManagementAuth } from '~/core/composable/voucher-purchase/useVoucherManagementAuth'
import { useVoucherPurchaseConditions } from '~/core/composable/voucher-purchase/useVoucherPurchaseConditions'

import { Money } from '~/core/ts/entity/Money'
import { VoucherPurchase } from '~/core/ts/entity/VoucherPurchase'
import { Voucher } from '~/core/ts/entity/Voucher'

import ManageVoucherFAQRepository from '~/core/ts/repository/ManageVoucherFAQRepository'
import { translateByKey } from '~/core/ts/util/translate'
import HeadMetaBuilder from '~/core/ts/util/HeadMetaBuilder'

definePageMeta({
  layout: 'checkout',
})

export default defineNuxtComponent({
  components: {
    LoadingSpinner,
    Card,
    SplInputBox,
    SplEmailInput,
    SplButton,
    SelectBox,
    Separator,
    Modal,
    FAQList,
    DownloadIcon,
    SmallArrowIcon,
    VoucherListItem,
    VoucherPurchaseConditions,
    HBSPTVoucherServiceChange,
  },
  setup() {
    const {
      voucherPurchase,
      beneficiaryName,
      saveBeneficiaryEdit,
      cancelBeneficiaryEdit,
      downloadVoucher,
      cancelVoucher,
      cancelReasonList,
      currentCancellationReason,
      currentCancellationReasonLabel,
      onCancellationReasonSelected,
      needsCancellationReasonError,
      cancellationReasonUserExtra,
    } = useVoucherManagementForm()

    const {
      logOff,
    } = useVoucherManagementAuth()

    const runtime = useRuntimeConfig()

    const voucherBuyerEmail = computed(() => {
      const purchase = voucherPurchase.value
      if (!purchase) {
        return ''
      }

      return purchase.buyer.email
    })

    const voucherBuyerName = computed(() => {
      const purchase = voucherPurchase.value
      if (!purchase) {
        return ''
      }

      return `${purchase.buyer.name} ${purchase.buyer.surname}`
    })

    const voucherCode = computed(() => {
      const purchase = voucherPurchase.value
      if (!purchase) {
        return ''
      }

      if (!purchase.vouchers.length) {
        return ''
      }

      const voucher = purchase.vouchers[0]
      return voucher.voucherCode
    })

    const giftNameSurname = computed(() => {
      const purchase = voucherPurchase.value
      if (!purchase) {
        return ''
      }

      if (!purchase.vouchers.length) {
        return ''
      }
      const voucher = purchase.vouchers[0]

      const name = voucher.client.personalData.name
      const surname = voucher.client.personalData.surname

      return `${name} ${surname}`
    })

    const voucherPurchaseFinalPrice = computed(() => {
      const purchase = voucherPurchase.value
      if (!purchase) {
        return Money.fromAmount(0)
      }

      return purchase.pricing.final
    })

    const voucherPurchaseConfirmedPaymentType = computed(() => {
      const purchase = voucherPurchase.value
      if (!purchase) {
        return ''
      }

      const payment = VoucherPurchase.getConfirmedPayment(purchase)
      if (!payment) {
        return ''
      }

      if (payment.type === 'RedsysInSitePaymentMethod') {
        return 'Redsys'
      }

      if (payment.type === 'PaypalPaymentMethod') {
        return 'Paypal'
      }
    })

    const voucherPurchaseSpaName = computed(() => {
      const purchase = voucherPurchase.value
      if (!purchase) {
        return ''
      }

      return purchase.spa.name
    })

    const isVoucherExpired = computed(() => {
      const purchase = voucherPurchase.value
      if (!purchase) {
        return false
      }

      if (!purchase.vouchers.length) {
        return false
      }

      const voucher = purchase.vouchers[0]
      const voucherExpirationStamp = voucher.expirationDate.getTime()

      const todayStamp = Date.now()

      if (voucherExpirationStamp > todayStamp) {
        return false
      }

      return true
    })

    const isVoucherExchanged = computed(() => {
      const purchase = voucherPurchase.value
      if (!purchase) {
        return false
      }

      if (!purchase.vouchers.length) {
        return false
      }

      const voucher = purchase.vouchers[0]
      return Voucher.isExchanged(voucher)
    })

    const isVoucherCancelled = computed(() => {
      const purchase = voucherPurchase.value
      if (!purchase) {
        return false
      }

      if (!purchase.vouchers.length) {
        return false
      }

      const voucher = purchase.vouchers[0]
      return Voucher.isCancelled(voucher)
    })

    const isAfterMorethan14Days = computed(() => {
      const purchase = voucherPurchase.value
      if (!purchase) {
        return false
      }

      const confirmStamp = purchase.status.confirmedOn.getTime()
      const todayStamp = Date.now()

      const dayDiff = Math.ceil((todayStamp - confirmStamp) / 1000 / 60 / 60 / 24)
      return dayDiff > 14
    })

    const faqItems = ManageVoucherFAQRepository.get()

    const isEditModalOpened = ref(false)
    function openEditModal() {
      isEditModalOpened.value = true
    }
    function closeEditModal() {
      isEditModalOpened.value = false
      editModalHasErrors.value = false
      editModalSuccess.value = false
      cancelBeneficiaryEdit()
    }

    const editModalHasErrors = ref(false)
    const editModalSuccess = ref(false)

    async function saveBeneficiaryEditWrapper() {
      if (!beneficiaryName.value.trim().length) {
        editModalHasErrors.value = true
        return
      }

      await saveBeneficiaryEdit()
      editModalHasErrors.value = false
      editModalSuccess.value = true
    }

    function onEditInputBlur() {
      if (!beneficiaryName.value.trim().length) {
        cancelBeneficiaryEdit()
      }
    }

    function onEditInputFocus() {
      beneficiaryName.value = ''
    }

    const isRedeemModalOpened = ref(false)
    function openRedeemModalOpened() {
      isRedeemModalOpened.value = true
    }

    const isCancelModalOpened = ref(false)
    function openCancelModalOpened() {
      isCancelModalOpened.value = true
      onCancellationReasonSelected(null)
    }

    async function cancelVoucherWrapper() {
      const success = await cancelVoucher()
      cancelModalSuccess.value = success
    }

    const cancelModalSuccess = ref(false)

    async function fromCancelToServiceChange() {
      isCancelModalOpened.value = false
      isServiceChangeModalOpened.value = true
    }

    const isServiceChangeModalOpened = ref(false)
    function openServiceChangeModalOpened() {
      isServiceChangeModalOpened.value = true
    }

    const isExtendModalOpened = ref(false)
    function openExtendModalOpened() {
      isExtendModalOpened.value = true
    }

    const isConditionsModalOpened = ref(false)
    function openConditionsModalOpened() {
      isConditionsModalOpened.value = true
    }

    const {
      serviceTermsAndConditions,
      spaConditons,
      spalopiaConditons,
      spaName,
      spaContact,
    } = useVoucherPurchaseConditions(voucherPurchase)

    const title = translateByKey('manage-voucher-shorttitle')
    const builder = HeadMetaBuilder.create()
    builder.withTitleAndMetaTitle(`${title} | Spalopia.com`)
    useHead(builder.get())

    return {
      isDev: runtime.public.isDev,

      logOff,

      voucherPurchase,
      beneficiaryName,

      saveBeneficiaryEdit,
      cancelBeneficiaryEdit,

      voucherBuyerEmail,
      voucherBuyerName,

      voucherCode,

      giftNameSurname,

      voucherPurchaseFinalPrice,
      voucherPurchaseConfirmedPaymentType,
      voucherPurchaseSpaName,

      isVoucherExpired,
      isVoucherExchanged,
      isVoucherCancelled,
      isAfterMorethan14Days,

      downloadVoucher,

      faqItems,

      isEditModalOpened,
      editModalHasErrors,
      editModalSuccess,
      onEditInputBlur,
      onEditInputFocus,
      openEditModal,
      closeEditModal,
      saveBeneficiaryEditWrapper,

      isRedeemModalOpened,
      openRedeemModalOpened,

      isCancelModalOpened,
      cancelModalSuccess,
      openCancelModalOpened,
      cancelVoucherWrapper,

      fromCancelToServiceChange,

      cancelReasonList,
      currentCancellationReason,
      currentCancellationReasonLabel,
      onCancellationReasonSelected,

      needsCancellationReasonError,
      cancellationReasonUserExtra,

      isServiceChangeModalOpened,
      openServiceChangeModalOpened,

      isExtendModalOpened,
      openExtendModalOpened,

      isConditionsModalOpened,
      openConditionsModalOpened,

      // Condiciones
      serviceTermsAndConditions,
      spaConditons,
      spalopiaConditons,
      spaName,
      spaContact,
    }
  },
})
</script>

<style lang="scss" scoped>
.manage-voucher {
  @apply bg-white;
  @apply py-2;
  @apply px-4;

  @screen md {
    @apply p-6;
  }

  &__wrapper {
    @apply my-2;

    @apply w-full;
    @apply mx-auto;

    @screen md {
      @apply w-full;
    }

    @screen lg {
      @apply w-4/5;
    }

    @screen xl {
      @apply w-2/3;
    }
  }

  &__log-off-btn {
    @apply py-2;
  }

  &__modal {
    &__highlight {
      @apply font-bold;
      @apply text-spl-primary-dark;

      @apply text-lg;

      @apply py-2;
    }

    &__paragraph {
      @apply py-2;
    }

    &__email {
      @apply p-2;
      @apply text-center;

      @apply text-lg;
      @apply font-bold;

      @apply text-spl-primary-dark;
    }

    &__email:hover {
      @apply text-spl-primary;
    }

    &__extend {
      @apply py-2;
    }

    &__contact-spa {
      @apply py-2;

      &__expired-notice {
        @apply mb-4;
      }

      &__data {
        @apply mt-2;

        &__list {
          @apply list-disc;
          @apply ml-6;
        }
      }
    }

    &__edit {
      @apply mt-6;

      @screen md {
        @apply mt-8;
      }

      &__input {
        @apply border-1;

        @apply border-spl-gray-1;
      }

      &__error {
        @apply pl-2;
        @apply py-1;

        @apply text-red-900;
      }

      &__success-top {
        @apply flex;
        @apply flex-col;

        @apply justify-center;
        @apply items-center;

        &__label {
          @apply py-2;

          @apply font-bold;
          @apply text-spl-dark;
        }

        &__beneficiary {
          @apply py-2;
          @apply px-8;

          @apply font-bold;
          @apply text-xl;

          @apply border-1;

          @apply text-spl-primary;
        }
      }

      &__success-bottom {
        @apply pt-8;
        @apply pb-6;

        @apply font-bold;
        @apply text-spl-primary;

        @apply text-center;

        &__head {
          @apply text-xl;
        }

        &__subhead {
          @apply pt-2;
          @apply text-spl-primary-dark;
        }

        &__btn {
          @apply pt-6;
          @apply pb-8;
        }
      }

      &__btns {
        @apply flex;
        @apply justify-center;
        @apply gap-4;

        @apply mt-8;

        @apply flex-col;

        @screen md {
          @apply flex-row;
        }
      }
    }

    &__cancel {
      &__head {
        @apply pt-2;
        @apply pb-1;

        @apply font-bold;
      }

      &__text {
        @apply py-2;
      }

      &__center-text {
        @apply py-2;
        @apply text-center;
      }

      &__thanks {
        @apply py-4;

        @apply text-spl-primary-dark;

        @apply text-lg;
        @apply font-bold;

        @apply text-center;
      }

      &__list {
        list-style: circle;
        @apply my-1;

        li {
          @apply ml-6;
        }
      }

      &__btns {
        @apply flex;
        @apply justify-center;
        @apply gap-4;

        @apply mt-8;

        @apply flex-col;

        @screen md {
          @apply flex-row;
        }
      }

      &__selector {
        @apply mt-4;
        @apply border-t-1;
        @apply pt-2;

        &__header {
          @apply pt-4;
          @apply text-spl-gray-5;
        }

        &__error {
          @apply py-1;
          @apply italic;
          @apply text-red-900;
        }

        &__extra {
          @apply pt-4;
          &__header {
            @apply pb-2;
          }

          &__input {
            @apply border-1;
            @apply border-spl-gray-1;
          }
        }
      }
    }
  }

  &__log-off-link {
    @apply flex;
    @apply justify-center;
    @apply gap-2;
  }

  &__spa-terms-conditions {
    p {
      @apply my-1;
    }

    h4 {
      @apply my-2;
      @apply font-bold;
      @apply text-spl-primary-dark;
    }
  }

  &__header {
    @apply pt-4;
    @apply pb-8;

    &__title {
      @apply text-3xl;
      @apply font-bold;
      @apply text-spl-primary-dark;

      @apply text-center;
    }

    &__subtitle {
      @apply text-2xl;
      @apply text-spl-primary-dark;

      @apply text-center;
      @apply py-4;
    }

    &__info {
      @apply text-lg;

      @apply text-center;
    }
  }

  &__form {
    @screen md {
      @apply grid;
      @apply grid-cols-2;

      @apply gap-4;
    }

    @screen lg {
      @apply gap-14;
    }

    &__service {
      &__conditions {
        @apply mt-2;
        @apply py-2;
        @apply flex;
        @apply justify-between;
        @apply items-center;

        @apply gap-2;

        @apply text-base;

        &__download {
          @apply flex;
          @apply justify-between;
          @apply items-center;

          @apply gap-2;
        }
      }
    }

    &__purchase {
      @apply my-8;

      @apply flex;
      @apply flex-col;
      @apply gap-6;

      @screen md {
        @apply my-0;
      }

      &__info{
        &__header {
          @apply text-lg;

          @apply py-2;
          @apply font-bold;
          @apply text-spl-primary-dark;

          @apply border-b-1;
        }

        &__body {
          @apply mb-4;

          .label {
            @apply font-bold;
            @apply text-spl-primary-dark;
          }
        }
      }

      &__edit {
        @apply flex;
        @apply items-center;
        @apply justify-center;
      }

      &__actions {
        @apply pt-4;

        @apply flex;
        @apply flex-col;
        @apply gap-2;
      }
    }
  }

  &__faq {
    @apply py-8;
    @apply mx-auto;

    &__header {
      @apply text-2xl;

      @apply text-spl-primary-dark;

      @apply text-center;

      @apply py-4;
    }

    &__item {
      @apply mb-4;
    }

    @screen md {
      @apply mt-12;
    }
  }
}
</style>
